import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/free-solid-svg-icons';

function Mpesa_school_portal({  
  school_name,
  location,
  adress,
  email,
  contact,
  contacteename,
  intakedirecto,
  paymentg}) {

  const [phone, setPhone] = useState()

    const pay = () =>{
      if (!phone) {
        alert('Please add Phone Number!!')
      } else {

        const loginData = {
          num: phone
       
        };
  
              // Send data to the PHP backend using fetch
              fetch('https://hosteladventures.site/PHP/MPESA/Real_est.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginData)
              })
                .then(response => response.json())
                .then(data => {
                  // Handle response from backend (e.g., login success or failure)
                  console.log(data)
               
                })
                .catch(error => {
                  console.error('Error:', error);
                });
        
      }
      const loginData = {
        school_name: school_name,
        location: location,
        adress: adress,
        email: email,
        contact: contact,
        contacteename: contacteename,
        intakedirecto: intakedirecto,
        paymentg: paymentg
        };

              // Send data to the PHP backend using fetch
              fetch('https://hosteladventures.site/PHP/MPESA/PHP/School_portal.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginData)
              })
                .then(response => response.json())
                .then(data => {
                  // Handle response from backend (e.g., login success or failure)
                  alert(data.message)
               
                })
                .catch(error => {
                  console.error('Error:', error);
                });

    }
  return (
    <div  className='inner_TC_MAIN'>
     <div className='Main_MPESA_inner'>
       <FontAwesomeIcon icon={faMobile} className='phoneMpesa' />
       <p className='fee'>Pay a fee of Ksh 500 via Mpesa to Finalize</p>

       <input placeholder='Add Mpesa Number, start with 254 not +254' onChange={(event) => setPhone(event.target.value)} />

       <div className='T_C_Buttons'>
        <button className='acc_BTN' onClick={pay}>pay</button>
        <button className='dec_BTN'>don't pay</button>
     </div>
    </div>
    </div>
  )
}

export default Mpesa_school_portal